import type { ReactNode } from "react";

export function KpiCard({
  label,
  value,
  hint,
  accent,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  accent?: boolean;
}) {
  return (
    <div className="rounded-xl bg-card p-5 ring-1 ring-border">
      <p className={`mb-3 text-[11px] font-medium uppercase tracking-wider ${accent ? "text-brand" : "text-muted-foreground"}`}>
        {label}
      </p>
      <p className="font-mono text-2xl font-medium tracking-tight">{value}</p>
      {hint ? <div className="mt-2 text-[11px] text-muted-foreground">{hint}</div> : null}
    </div>
  );
}
